var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.92857C6 9.24416 5.74416 9.5 5.42857 9.5L4.57143 9.5C4.25584 9.5 4 9.24416 4 8.92857L4 4.15546C4 3.83987 4.25584 3.58403 4.57143 3.58403L5.42857 3.58403C5.74416 3.58403 6 3.83987 6 4.15546L6 8.92857Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.93699C6 2.25259 5.74416 2.50842 5.42857 2.50842L4.57143 2.50842C4.25584 2.50842 4 2.25259 4 1.93699L4 0.928591C4 0.612999 4.25584 0.357162 4.57143 0.357162L5.42857 0.357162C5.74416 0.357162 6 0.612999 6 0.92859L6 1.93699Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.f5b40ba7c985395b550f46c3465e1a41.svg";
export { ForwardRef as ReactComponent };